<template>
  <div class="legal width">
      <div class="directory">
        <p><span>法律事务</span></p>
        <ul>
          <li v-for="(item, index) in list" @click="$router.replace(item.path)" v-bind:key="index">
            <span>{{item.text}}</span>
            <i class="el-icon-arrow-right"></i>
          </li>
        </ul>
      </div>
      <div class="content">
            <router-view />
        </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
        list:[
            {
                text: '经典案例',
                path: '/legal'
            },
            {
                text: '版权调解',
                path: '/legal/mediation'
            },
        ]
    };
  },
  mounted() {},
  methods: {},
};
</script>
<style scoped>
.legal {
		margin: 20px auto;
		margin-bottom: 100px;
		display: flex;
	}

	.directory {
		width: 15%;
	}

	.directory p,
	.contact p {
		border-bottom: 1px solid #ddd;
		box-sizing: border-box;
		margin-top: 20px;
	}

	.directory p span,
	.contact p span {
		display: inline-block;
		padding: 7px 10px;
		font-weight: bold;
		border-bottom: 2px solid #016fb8;
	}

	.directory ul {
		margin-top: 10px;
	}

	.directory ul li span {
		width: 140px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.directory ul li span:hover {
		color: #016fb8;
		font-weight: bold;
		cursor: pointer;
	}

	.directory ul li {
		background: #ddd;
		margin-top: 4px;
		padding: 10px;
		color: gray;
		font-size: 14px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.content {
		width: 80%;
		margin-top: 27px;
		margin-left: 30px;
	}
</style>